import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const DeleteEventConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="delete-event-confirm-title"
    >
      <Box sx={modalStyle} className="event-confirm-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="delete-event-confirm-title">Delete Event?</h2>
        <p className="event-confirm-modal__body">
          Are you sure you want to delete this event? This action cannot be
          undone.
        </p>

        <div className="event-confirm-modal__actions">
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-muted"
            disableElevation
            onClick={onClose}
            disabled={confirming}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-primary"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
